export const getWorkbookRoutePrefix = (pathname = "") => {
  const [prefix] = pathname.split("/workbook");
  return `${prefix || "/app/organization"}/workbook`;
};

export const isReadOnlyWorkbookRoute = (pathname = "", routeState = {}) =>
  Boolean(routeState?.readOnly) || getWorkbookRoutePrefix(pathname) !== "/app/organization/workbook";

export const workbookPath = (routePrefix, suffix = "") => {
  const normalizedPrefix = routePrefix || "/app/organization/workbook";
  if (!suffix) return normalizedPrefix;
  return `${normalizedPrefix}/${suffix.replace(/^\/+/, "")}`;
};
